export default __webpack_public_path__ + "static/media/reg_fazioni.b88eac37.pdf";